import { render, staticRenderFns } from "./WarehouseQuantity.vue?vue&type=template&id=40cd9d8e&scoped=true&"
import script from "./WarehouseQuantity.vue?vue&type=script&lang=js&"
export * from "./WarehouseQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd9d8e",
  null
  
)

export default component.exports